import { LocationActions, LocationActionTypes } from '@app/core/ngrx';

export interface LocationState {
  loaded: boolean;
  pending: boolean;
  error: any;
  location: {
    refresh?: number;
    location?: string;
  };
}

export const LOCATION_INITIAL_STATE: LocationState = {
  loaded: false,
  pending: false,
  error: null,
  location: { refresh: 0 },
};

export const locationReducer = (
  state: LocationState = LOCATION_INITIAL_STATE,
  action: LocationActions,
): LocationState => {
  switch (action.type) {
    case LocationActionTypes.LOAD_LOCATION:
      return {
        error: null,
        pending: false,
        ...state,
        loaded: true,
        location: action.payload,
      };
    case LocationActionTypes.REFRESH_LOCATION:
      return {
        ...state,
        location: {
          ...state.location,
          refresh: state.location.refresh + 1,
        },
      };
    default:
      return state;
  }
};
